import { Route } from '@angular/router';
import { PreloginComponent } from './pre-login';
import { AuthCallbackComponent } from './auth-callback/auth-callback';

/**
 * Defines the routes for the pre-login feature module, including the login page and a wildcard route to handle undefined paths. 
 * The login page is loaded lazily to optimize performance.
 */
export const preLoginRoutes: Route[] = [
  {
    path: 'public',
    component: PreloginComponent,
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./login/login').then((m) => m.LoginComponent),
      },
    {
        path: '**',
        redirectTo: 'login',
      },
    ],
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
  }

  
];

